import { render, staticRenderFns } from "./ContentAddGdComponent.vue?vue&type=template&id=572e300f&scoped=true"
import script from "./ContentAddGdComponent.vue?vue&type=script&lang=js"
export * from "./ContentAddGdComponent.vue?vue&type=script&lang=js"
import style0 from "./ContentAddGdComponent.vue?vue&type=style&index=0&id=572e300f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572e300f",
  null
  
)

export default component.exports